import React from "react";
import Typography from "@material-ui/core/Typography";
const Authorization = ({}) => {
  return (
    <React.Fragment>
      <Typography paragraph variant="h4">
        Authorization
      </Typography>
      <Typography paragraph variant="h5">
        Manage authorization master data for access of every roles
      </Typography>
      <Typography paragraph variant="body1">
        Authorization is one of the features under the User module to manage the
        authorization master data to define any features that can be accessed by
        the user or user group. It contains any information regarding the
        authorization only. Later, authorization will be assigned to the user or
        user group.
      </Typography>
      <Typography paragraph variant="h5" className="mt-5">
        How it works
      </Typography>
      <Typography paragraph variant="body1">
        The first information displayed on this feature is the Authorization
        list. It is displayed like a table that contains download functions,
        sort, filter, and global search on the header area, and contains data
        navigation and refresh function on the footer area. The data column that
        appears in this table list are listed below:
      </Typography>
      <Typography paragraph variant="body1">
        <b>Authorization ID</b>
        <br />
        Indicates the ID of the Authorization.
      </Typography>
      <Typography paragraph variant="body1">
        <b>Authorization Name</b>
        <br />
        Indicates the name of the Authorization.
      </Typography>
      <Typography paragraph variant="body1">
        Apart from the column appearing on the table list, there are more
        columns available on each row by clicking the expand button on the left
        side of each data.
      </Typography>
      <Typography paragraph variant="body1">
        Besides, there are 3 buttons that appear on each row of Authorization
        data with specific conditions explained below:
      </Typography>
      <Typography paragraph variant="body1">
        <b>Edit Authorization</b>
        <br />
        This button is used to edit the Authorization data. Any records that
        have the 'Standard record protection' icon are unable to be edited.
      </Typography>
      <Typography paragraph variant="body1">
        <b>Authorization Detail</b>
        <br />
        This button is used to navigate to the Authorization detail in
        non-editable mode.
      </Typography>
      <Typography paragraph variant="body1">
        <b>Delete Authorization</b>
        <br />
        This button is used to delete the Authorization data. Any records that
        have the 'Standard record protection' icon are unable to be deleted.
      </Typography>
    </React.Fragment>
  );
};

export default Authorization;
